import { createTheme } from '@mui/material/styles'

const theme = createTheme({
   typography: {
      fontFamily: 'Sour Gummy, Arial, sans-serif',
   },
})

export default theme
